module.exports = __webpack_public_path__ + "72758418d18b94af35539c113a7f62b3.png";